import React from 'react';
import { Heading, Link, Image, Paragraph, IconSVG } from 'components';
import './BoxProfile.scss';

const BoxProfile = ({
  backgroundColor,
  textColor,
  photo,
  name,
  job,
  facebook,
  quora,
  linkedin,
  twitter,
  additionalClass,
}) => (
  <div className={`box-profile ${additionalClass}`}>
    <div className={'box-profile__top'}>
      <Image
        style={{
          objectPosition: 'top center',
        }}
        src={photo}
        alt={`${name} photo`}
        placeholder
      />
    </div>
    <div
      className={`box-profile__bottom box-profile__bottom--${backgroundColor}`}
    >
      <div>
        <Heading type={3} color={textColor} size={'medium'}>
          {name}
        </Heading>
        <Paragraph color={textColor} additionalClass={'text--default'}>
          {job}
        </Paragraph>
      </div>
      {(facebook || linkedin || twitter || quora) && (
        <div className={'box-profile__connect'}>
          <Paragraph color={textColor} additionalClass={'text--bold'}>
            Connect with me
          </Paragraph>
          <div className={'box-profile__social-media'}>
            {facebook && (
              <Link to={facebook}>
                <IconSVG name={'facebook'} color={textColor} />
              </Link>
            )}
            {linkedin && (
              <Link to={linkedin}>
                <IconSVG name={'linkedin'} color={textColor} />
              </Link>
            )}
            {twitter && (
              <Link to={twitter}>
                <IconSVG name={'twitter'} color={textColor} />
              </Link>
            )}
            {quora && (
              <Link to={quora}>
                <IconSVG name={'quora'} color={textColor} />
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  </div>
);

BoxProfile.defaultProps = {
  additionalClass: '',
  backgroundColor: 'red',
  textColor: 'white',
};

export default BoxProfile;
